import { z } from "zod";

export const createOrderIdentificationSchema = (t: (key: string) => string) =>
  z.object({
    orderName: z.string().min(1, t("common.error.fieldRequired")),
    secondaryInput: z.string().optional(),
  });

export type OrderIdentificationFormValues = z.infer<
  ReturnType<typeof createOrderIdentificationSchema>
>;
